"use client"

import { useEffect, useSyncExternalStore } from "react"
import Image from "next/image"
import Link from "next/link"
import { registerBonusProgramAfterSuccessfulOrderAction } from "@/actions/bonusProgramActions"
import { useTranslations } from "next-intl"

import {
  BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY,
  BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY,
} from "@/lib/storefront/account/bonus-program-checkout"

interface CheckoutBonusProgramLandingpageHintClientProps {
  landingpageHref: string
}

function subscribeBonusProgramCheckoutIntent() {
  return () => undefined
}

export default function CheckoutBonusProgramLandingpageHintClient(
  props: CheckoutBonusProgramLandingpageHintClientProps
) {
  const t = useTranslations("storefront")
  const showHint = useSyncExternalStore(
    subscribeBonusProgramCheckoutIntent,
    () => {
      if (!props.landingpageHref || typeof window === "undefined") {
        return false
      }

      const intent = window.sessionStorage.getItem(BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY)
      const consumedIntent = window.sessionStorage.getItem(BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY)
      return intent !== "true" && consumedIntent !== "true"
    },
    () => false
  )

  useEffect(() => {
    if (!props.landingpageHref || typeof window === "undefined") {
      return
    }

    const intent = window.sessionStorage.getItem(BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY)
    const consumedIntent = window.sessionStorage.getItem(BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY)

    if (intent === "true" && consumedIntent !== "true") {
      window.sessionStorage.setItem(BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY, "true")
      window.sessionStorage.removeItem(BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY)
      registerBonusProgramAfterSuccessfulOrderAction()
    }
  }, [props.landingpageHref])

  if (!showHint) {
    return null
  }

  return (
    <div className={"rounded-sm border border-gray-200 bg-white p-4 text-sm"}>
      <div className={"flex gap-3"}>
        <Image
          src={"/img/Bonus_Icon.png"}
          alt={""}
          width={200}
          height={60}
          className={"mt-0.5 h-auto max-h-[60px] w-[200px] shrink-0 rounded-sm object-contain"}
        />
        <div>
          <p className={"font-semibold"}>{t("checkout.bonus_program.confirmation_hint_title")}</p>
          <p className={"mt-1"}>{t("checkout.bonus_program.confirmation_hint_text")}</p>
          <Link
            prefetch={false}
            href={props.landingpageHref}
            className={"mt-2 inline-block font-semibold text-primary underline"}
          >
            {t("checkout.bonus_program.confirmation_hint_link")}
          </Link>
        </div>
      </div>
    </div>
  )
}
